import { memo } from 'react'

import * as Styled from './styled'
import { IMediaControlItemProps } from './types'
import { Tooltip } from 'components/Tooltip'

const MediaControlItem = ({
  icon,
  onClick,
  tooltipText
}: IMediaControlItemProps) => (
  <Tooltip tooltipText={tooltipText || ''}>
    <Styled.MediaControlItem onClick={onClick}>{icon}</Styled.MediaControlItem>
  </Tooltip>
)

export default memo(MediaControlItem)
